import { render } from "./CobrancasPage.vue?vue&type=template&id=255c70e1&scoped=true"
import script from "./CobrancasPage.vue?vue&type=script&lang=js"
export * from "./CobrancasPage.vue?vue&type=script&lang=js"

import "./CobrancasPage.vue?vue&type=style&index=0&id=255c70e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255c70e1"]])

export default __exports__